import React, { lazy, Suspense, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import PlainLayout from "../layouts/PlainLayout";
import MainLayout from "../layouts/MainLayout";
import ResearchLayout from "../layouts/ResearchLayout";
import Authorize from "../modules/authorize";
import { setMapMode } from "../redux/mapMode/action";
import {
  Login,
  Learn,
  DAO,
  DaoDetails,
  MarketPlace,
  MyLands,
  NftBox,
  Notifications,
  PreFight,
  Referrals,
  Trade,
  TransactionHistory,
  WithdrawHistory,
  Adventure,
  BattleReplay,
  MyLandsNew,
  TroopOrderBook,
  ItemOrderBook,
  DungeonWating,
  ReferralLeaderBoard,
  TreasurePage,
  TreasureReplay,
  GLogin,
  TreasureWating,
  TreasureDetail,
  TreasureOrder,
  JoinTreasure,
  ModifyTreasure,
  BetaLeaderBoard,
  DungeonSelect,
  TreasureLose,
  Ranking,
  PublicProfile,
  Growth,
  GuildPage,
  NotFound,
  BattleLayout,
  PreFightContainer,
  Profile as ProfilePage,
  Research,
  ResearchDetail,
} from "../pages";
import Barracks from "../pages/Barracks";
import FriendlyMatchBox from "../game-engine/components/home/friendly-match";
import WatchScreen from "../game-engine/screens/watch";
import ArenaLeaderBoard from "../game-engine/screens/leader-board";
import MatchSuggestion from "../game-engine/components/home/match-suggestion";
import JoinBattle from "../game-engine/components/home/join-battle";
import VillageMap from "../pages/village";
import MapLayout from "../layouts/MainLayout/map-layout";
import Adventure3DReplay from "../pages/Adventure3DReplay";
import TalentSystemExample from "../examples/TalentSystemExample";

const BattleContainer = lazy(() => import("../modules/battle-container"));
const BattleResultComponent = lazy(
  () => import("../components/BattleResultComponent")
);

const routeConfig = [
  { path: "/login", element: <Login /> },
  { path: "/g-login", element: <GLogin />, condition: "IsBeta" },
  { path: "/Default", element: <Navigate to="/" /> },
  { path: "/learn", element: <Learn /> },
  {
    path: "/battle",
    element: <PlainLayout transparent={true} />,
    children: [
      {
        path: "replay/:id",
        element: (
          <BattleContainer>
            <BattleReplay />
          </BattleContainer>
        ),
      },
      {
        path: "result/:id",
        element: <BattleResultComponent />,
      },
      {
        path: "order",
        element: (
          <PreFightContainer userConfig={{}} enableBgMusic={() => {}}>
            <PreFight />
          </PreFightContainer>
        ),
      },
      {
        path: "treasure/:id",
        element: (
          <BattleContainer>
            <TreasureReplay />
          </BattleContainer>
        ),
      },
    ],
  },
  {
    path: "/treasure",
    element: <PlainLayout transparent={true} />,
    children: [
      { path: "select", element: <TreasurePage /> },
      { path: "order", element: <TreasureOrder /> },
      { path: "join/:id", element: <JoinTreasure /> },
      { path: "modify/:id", element: <ModifyTreasure /> },
      { path: ":treasureID", element: <TreasureDetail /> },
    ],
  },
  {
    path: "/adventure/replay",
    element: <PlainLayout transparent={true} />,
    children: [
      {
        path: ":id",
        element: <Adventure3DReplay />,
      },
    ],
  },
  {
    path: "/dungeon",
    element: <PlainLayout transparent={true} />,
    children: [{ path: "select", element: <DungeonSelect /> }],
  },
  {
    path: "/village",
    element: <MapLayout />,
    children: [{ path: "/village/map", element: <VillageMap /> }],
  },
  {
    path: "/research",
    element: <ResearchLayout />,
    children: [
      { path: "/research", element: <Research /> },
      { path: "/research/:categoryId", element: <ResearchDetail /> },
    ],
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "marketplace/orderbook/troop", element: <TroopOrderBook /> },
      { path: "marketplace/orderbook/item", element: <ItemOrderBook /> },
      { path: "guild", element: <GuildPage /> },
      { path: "order", element: <TreasureOrder /> },
      { path: "ranking", element: <Ranking /> },
      { path: "trade/:id", element: <Trade /> },
      { path: "dao/:id", element: <DaoDetails /> },
      { path: "adventure/new", element: <Navigate to="/dungeon/select" /> },
      { path: "adventure/waiting/:id", element: <DungeonWating /> },
      { path: "adventure/waiting/treasure/:id", element: <TreasureWating /> },
      { path: "treasure-lose", element: <TreasureLose /> },
      { path: "adventure", element: <Adventure isPage /> },
      { path: "transaction-history", element: <TransactionHistory /> },
      { path: "withdraw-history", element: <WithdrawHistory /> },
      { path: "arena/host-match", element: <FriendlyMatchBox /> },
      { path: "arena/watch", element: <WatchScreen /> },
      { path: "arena/join-match", element: <JoinBattle /> },
      { path: "arena/leader-board/:type", element: <ArenaLeaderBoard /> },
      {
        path: "arena/leader-board",
        element: <Navigate to="/arena/leader-board/lords" />,
      },
      {
        path: "arena/battle-lobby",
        element: <MatchSuggestion timeout={30000} isJoinMatch={false} />,
      },
      {
        path: "beta-leaderboard",
        element: <BetaLeaderBoard />,
        condition: "IsBeta",
      },
      {
        path: "barracks",
        element: <Barracks />,
      },
      { path: "marketplace", element: <MarketPlace /> },
      { path: "lands", element: <MyLandsNew /> },
      { path: "my-lands", element: <MyLands /> },
      { path: "profile/:id", element: <PublicProfile /> },
      { path: "profile", element: <ProfilePage /> },
      { path: "referrals", element: <Referrals /> },
      { path: "referral-leaderboard", element: <ReferralLeaderBoard /> },
      { path: "mint-lands", element: <NftBox /> },
      { path: "dao", element: <DAO /> },
      { path: "notifications", element: <Notifications /> },
      { path: "trade", element: <NftBox /> },
      { path: "growth", element: <Growth /> },
      { path: "authorize", element: <Authorize /> },
      { path: "talent-system", element: <TalentSystemExample /> },
      { path: "", element: <Navigate to="/home?map=new" /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  { path: "/arena/*", element: <BattleLayout /> },
  { path: "/MarketPlace", element: <Navigate to="/marketplace" /> },
  { path: "/Lands", element: <Navigate to="/my-lands" /> },
  { path: "/MintLands", element: <Navigate to="/mint-lands" /> },
];

const RoutesConfig = ({ enableBgMusic, userSettings, IsBeta }) => {
  const dispatch = useDispatch();

  // The old home page is deprecated — the new map is now the only home.
  // Force map mode on so every consumer of `state.mapMode` (sound, navbar…)
  // behaves consistently, even for users who previously toggled to "old".
  const isMapMode = true;
  useEffect(() => {
    dispatch(setMapMode(true));
  }, [dispatch]);

  const renderRoutes = (routes) => {
    return routes.map((route) => {
      const { path, element, children, condition } = route;

      if (
        condition &&
        ((condition === "IsBeta" && !IsBeta) ||
          (condition === "!IsBeta" && IsBeta))
      ) {
        return null;
      }

      return (
        <Route
          key={path}
          path={path}
          element={React.cloneElement(element, {
            enableBgMusic,
            userSettings,
            isMapMode,
          })}
        >
          {children && renderRoutes(children)}
        </Route>
      );
    });
  };

  return (
    <Routes>
      {/* Home is always the new map now (old home page deprecated). */}
      <Route path="/home" element={<MapLayout />}>
        <Route index element={<VillageMap />} />
      </Route>

      {renderRoutes(routeConfig)}
    </Routes>
  );
};

export default RoutesConfig;
